import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./common";

export function FaqSection({ faqs, eyebrow = "FAQ", title = "Frequently asked questions", intro }) {
  return (
    <section data-testid="faq-section" className="py-24 md:py-32 border-t border-[#808080]/20">
      <div className="container-x mx-auto max-w-[1400px] grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-20">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-lime">{eyebrow}</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-4">{title}</h2>
          {intro && <p className="text-grey text-lg mt-6 max-w-md">{intro}</p>}
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="border-t border-[#808080]/30">
            {faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-[#808080]/30">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-base md:text-lg font-semibold text-white hover:no-underline hover:text-lime [&>svg]:text-lime [&>svg]:h-5 [&>svg]:w-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-grey text-base leading-relaxed pb-6 pr-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
